<form [formGroup]="loonInternationaleOrganisatie">
    <div *ngIf="loonVanInternationaleOrganisatie.length > 0" class="row">
        <div formArrayName="loonVanInternationaleOrganisatie">
            <div
                    *ngFor="let loon of loonVanInternationaleOrganisatie.controls; let i = index;"
                    [formGroupName]="i" class="row">
                <div class="col-auto row" formGroupName="loon">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Internationale organisatie' : ''"
                                                    class="col-auto custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Loon' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedrag"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                </div>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag premieloon' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="deelPremieloonVolksverzekeringen"
                                                  id="deelPremieloonVolksverzekeringen"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Zvw land' : ''"
                                                  [options]="optionsZvw"
                                                  [required]=true
                                                  class="col-auto custom-input-150"
                                                  formControlName="afdrachtZVWinNLmoetnog"

                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Btl loonheffing' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="loonheffing"
                                                  id="buitenlandseLoonheffing"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Tegenwoordig / Vroeger' : ''"
                                                  [options]="optionsTegenwoordig"
                                                  [required]=true
                                                  class="col-auto custom-input-200"
                                                  formControlName="tegenwoordigeDienstbetrekking"

                >
                </snelstart-ui-select-form-control>
                <div class="col-auto">
                    <snelstart-ui-button (click)="verwijderRijLoonInternationaleOrganisatie(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="delete"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>

            </div>
        </div>
    </div>
</form>

<div *ngIf="loonVanInternationaleOrganisatie.length === 0">
    <snelstart-ui-button (click)="addRijLoonInternationaleOrganisatie()" class="snelstart-ui-button" icon="plus"
                         type="link">Vrijgesteld loon invullen
    </snelstart-ui-button>
</div>
<div *ngIf="loonVanInternationaleOrganisatie.length > 0">
    <snelstart-ui-button (click)="addRijLoonInternationaleOrganisatie()" class="snelstart-ui-button" icon="plus"
                         type="link">Loon toevoegen
    </snelstart-ui-button>
</div>


